// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__183Tr","col":"styles_col__12clK"};